<section
  *transloco="let t"
  class="sign-up-container"
  [class.error]="submitted && !loading && failed"
  [class.ios-app]="redirect"
  [class.dialog]="inDialog"
  [class.small-mobileL]="(lessThan$ | async)?.mobileL"
  [class.small-xs]="(lessThan$ | async)?.xs">
  <nav class="dialog-head" *ngIf="inDialog">
    <button
      type="button"
      class="popsy-button-icon button"
      [class.rtl]="isRtlLayout$ | async"
      *ngIf="
        (previousMode === 'sign-in' || previousMode === 'auth-intro') &&
        !(submitted && success)
      "
      (click)="changeDialogMode(previousMode || 'sign-in')">
      <popsy-icon-arrow-left-1
        class="icon gray-dark"
        aria-hidden="true"></popsy-icon-arrow-left-1>
    </button>
    <div aria-hidden="true" class="dynamic-space"></div>
    <button type="button" class="popsy-button-icon button small" (click)="close(true)">
      <popsy-icon-remove class="icon gray-dark" aria-hidden="true"></popsy-icon-remove>
    </button>
  </nav>
  <form
    *ngIf="!(submitted && success)"
    class="form"
    name="sign-up"
    (ngSubmit)="signUp()"
    [formGroup]="signUpForm">
    <h2 class="title">{{ t('title_welcome') }}</h2>
    <div class="form-field" floatLabel="always" shouldLabelFloat hideRequiredMarker>
      <span class="label">{{ t('hint_username') }}</span>
      <input
        data-clarity-unmask
        #username
        name="name"
        autocomplete="name"
        type="text"
        class="field username"
        [class.rtl]="isRtlLayout$ | async"
        [formControl]="usernameFormControl"
        inputmode="text"
        [minlength]="minUsernameLength"
        [maxlength]="maxUsernameLength"
        required />
      <span class="error" *ngIf="signUpForm.controls['username'].hasError('required')">
        {{ t('error_username_required') }}
      </span>
      <span class="error" *ngIf="signUpForm.controls['username'].hasError('minlength')">
        {{ t('error_username_not_valid', { var1: minUsernameLength }) }}
      </span>
    </div>

    <div class="form-field" floatLabel="always">
      <span class="label">{{ t('hint_email') }}</span>
      <input
        data-clarity-unmask
        #email
        name="username"
        autocomplete="username"
        type="email"
        class="field"
        [formControl]="emailFormControl"
        inputmode="email"
        required />
      <span class="error" *ngIf="emailFieldErrors"> {{ emailFieldErrors }} </span>
    </div>

    <div class="form-field" [class.rtl]="isRtlLayout$ | async">
      <span class="label">{{ t('hint_password') }}</span>
      <input
        data-clarity-unmask
        #password
        autocomplete="password"
        name="password"
        class="field password"
        [type]="hidePassword ? 'password' : 'text'"
        [formControl]="passwordFormControl"
        required />
      <div class="button-wrap">
        <button
          type="button"
          tabindex="-1"
          (click)="togglePassword($event)"
          [attr.aria-label]="
            t(hidePassword ? 'action_hide_password' : 'action_show_password')
          "
          [attr.aria-pressed]="hidePassword">
          <ng-container *ngIf="!hidePassword">
            <popsy-icon-view-off
              class="icon gray-02"
              aria-hidden="true"></popsy-icon-view-off>
          </ng-container>
          <ng-container *ngIf="hidePassword">
            <popsy-icon-view-1
              class="icon gray-02"
              aria-hidden="true"></popsy-icon-view-1>
          </ng-container>
        </button>
      </div>

      <span class="error" *ngIf="passwordFieldErrors"> {{ passwordFieldErrors }} </span>
    </div>

    <div aria-hidden="true" class="dynamic-space"></div>
    <button type="submit" class="button popsy-button-primary" (click)="signUp()">
      <app-loading
        class="spinner"
        *ngIf="loading || signUpForm.status === 'PENDING'"></app-loading>
      <span *ngIf="!loading && signUpForm.status !== 'PENDING'" class="message">{{
        t('action_create_account')
      }}</span>
    </button>
    <div class="link-area" *ngIf="!inDialog">
      <a
        href=""
        [routerLink]="signInUrlFragment"
        [queryParams]="signUpQueryParams"
        (click)="stopPropagation()"
        >{{ t('menu_login') }}</a
      >
    </div>
    <div class="link-area" *ngIf="inDialog">
      <p (click)="changeDialogMode('sign-in')">{{ t('menu_login') }}</p>
    </div>
  </form>
  <div *ngIf="submitted && success" class="check-your-email">
    <popsy-icon-check-email
      class="illustration"
      aria-hidden="true"></popsy-icon-check-email>
    <div class="message">
      <h2 class="title">{{ t('mesage_forgot_confirmation') }}</h2>
      <h3 class="description">{{ t('message_confirm_registration') }}</h3>
      <div aria-hidden="true" class="dynamic-space"></div>
      <p class="info" [innerHTML]="helpText"></p>
    </div>
  </div>
</section>
